import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getConfig } from 'utils';

export const signIn = createAsyncThunk('SignIn', async (data) => {
    try {
        const res = await axios({

            method: "post",
            url: getConfig.API_URL + 'user_login',
            data: {
                "user_name": data?.phone,
                "user_password": data?.password,
                "user_type": 1
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const forgotPasswordSendOtp = createAsyncThunk('ForgotPasswordSendOtp', async ({ user_name }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'reset_request',
            data: {
                user_name,
                user_type: 1
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const forgotPasswordVerifyOtp = createAsyncThunk('ForgotPasswordVerifyOtp', async ({ user_name, user_otp }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'reset_verify_otp',
            data: {
                user_name,
                user_otp
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const forgotPasswordReset = createAsyncThunk('ForgotPasswordReset', async ({ user_name, user_otp, user_password }) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + 'reset_password',
            data: {
                user_name,
                user_otp,
                user_password
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})